import React from 'react';
import {ReactComponent as ConfettiIcon} from '../../assets/icons/icon_popup_confetti_new_version.svg'
import {ReactComponent as DangerIcon} from '../../assets/icons/icon_popup_danger_new_version.svg'
import {ReactComponent as ErrorIcon} from '../../assets/icons/icon_popup_error_new_version.svg'
import {ReactComponent as InfoIcon} from '../../assets/icons/icon_popup_info_new_version.svg'
import {ReactComponent as QuestionIcon} from '../../assets/icons/icon_popup_question_new_version.svg'
import {ReactComponent as SuccessIcon} from '../../assets/icons/icon_popup_success_new_version.svg'
import {ReactComponent as WarningIcon} from '../../assets/icons/icon_popup_warning_new_version.svg'
import {ReactComponent as HandStop} from '../../assets/icons/icon_popup_hand_stop_new_version.svg'
import {FeedbackTypes} from "../../app/interfaces";

interface PopupIconProps {
    type: FeedbackTypes
}

export const PopupIcon = ({type}:PopupIconProps) => {
    switch (type){
        case 'confetti' : return <ConfettiIcon/>
        case 'danger' : return <DangerIcon/>
        case 'warning' : return <WarningIcon/>
        case 'success' : return <SuccessIcon/>
        case 'question' : return <QuestionIcon/>
        case 'error' : return <ErrorIcon/>
        case 'info' : return <InfoIcon/>
        case 'hand_stop' : return <HandStop/>
        default: return <InfoIcon/>
    }
}
